import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Axios from 'axios';

import { withRouter } from 'react-router-dom';
// import { getOrgByID } from './graphql';
// import { apiUrl } from '../../config/properties';
import { herokuProxyHost, tomcatHostUpload } from '../../config/properties';


export default function UploadInventoryHOC(UploadInventoryPage) {
  class WrappedComponent extends Component {
    static propTypes = {
      onReturnToMainPage: PropTypes.func.isRequired,
      auth: PropTypes.shape({
        id: PropTypes.string,
        role: PropTypes.string,
        expiration: PropTypes.number,
        organizationId: PropTypes.string,
        jwtToken: PropTypes.string,
        email: PropTypes.string,
        cageCode: PropTypes.string,
      }).isRequired,
    };

    static initialState = {
      isLoading: true,
      errors: [],
      alertType: '',
      alertMessage: '',
    };

    state = WrappedComponent.initialState;

    // _onFileSelect seems to no be used anywhere
    // _onFileSelect = async (e, auth) => {
    //   this.setState({
    //     alertMessage: '',
    //     alertType: '',
    //   });
    //   try {
    //     const res = await S3FileUpload(e, auth, 'partnumbers');
    //     console.log(res);
    //     this.setState({
    //       alertType: 'success',
    //       alertMessage:
    //         'Upload successful! Your file has been successfully uploaded although it may take up to 30 minutes to see your results.',
    //     });
    //   } catch (error) {
    //     this.setState({
    //       alertType: 'warning',
    //       alertMessage:
    //         'File failed to upload. It seems something went wrong uploading your file.\n Please try again in a few minutes. If the problem persists, please contact support',
    //     });
    //   }
    // };

    _hideMessage = () => this.setState({ alertMessage: '', alertType: '' });

    _handleUpload = async option => {
      const { onSuccess, file } = option;
      const formData = new FormData();
      formData.set("fileToUpload", file);
      formData.set("cage", this.props.auth.cageCode);
      formData.set("email", this.props.auth.email);
      formData.set("type", "I");
      const config = {
        url: `${herokuProxyHost}/${tomcatHostUpload}`,
        method: 'post',
        headers: {
          Authorization: `Bearer ${this.props.auth.jwtToken}`,
          'Content-Type': 'multipart/form-data',
        },
        data: formData,
        onUploadProgress: ({ total, loaded }) => {
          this.setState({
            alertType: 'info',
            alertMessage: ` uploading ${Math.round(
              (loaded / total) * 100,
            ).toFixed(2)}%`,
          });
        },
      };

      try {
        const res = await Axios(config);
        onSuccess(res.data);
        this.setState({
          alertType: 'success',
          alertMessage:
            'Upload successful! Your file has been successfully uploaded although it may take up to 30 minutes to see your results.',
        });
      } catch (error) {
        this.setState({
          alertType: 'warning',
          alertMessage:
            'File failed to upload. It seems something went wrong uploading your file.\n Please try again in a few minutes. If the problem persists, please contact support',
        });
      }

    };


    render() {
      const { onReturnToMainPage } = this.props;
      const {
        alertType,
        alertMessage,
      } = this.state;

      // Configure Page
      const pageProps = {
        handleUpload: this._handleUpload,
        alertType,
        alertMessage,
        hideMessage: this._hideMessage,
        onReturnToMainPage
      };

      return <UploadInventoryPage {...pageProps} />;
    }
  }

  return withRouter(WrappedComponent);
}



// WEBPACK FOOTER //
// ./src/components/UploadInventory/UploadInventoryHOC.jsx